export const environment = {
  production: false,
  VERSION: '2.1.0',
  UPLOAD_API_URL:
    'https://api-dev.golfgameskeeper.com/API/GGKFileUpload.asmx/',
  DOC_API_URL:
    'https://api-dev.golfgameskeeper.com/API/GGKDocumentService.asmx/',
  BASE_API_URL:
    'https://api-dev.golfgameskeeper.com/API/',
  GGK_API_KEY: 'q@Inc2!dNr#5@yaF7LFec%9pr8mMATieQravnkOI',
  GOOGLE_LOGIN_CLIENT_ID: '586433516567-3l2dqcosq7o8rsvna2kbtmb04f7sosc4.apps.googleusercontent.com',
  GOOGLE_LOGIN_SECRET: 'jCg6q5rED95M1_O6etxn3Im-',
  APPLE_CLIENT_ID: "com.golfgameskeeper.web",
  FACEBOOK_APP_ID: "977356252430705",
  STRIPE_CONNECT: "ca_F7eeIp0d7fBxxwUA4HCMPNHVldfspPzl",
  use_usga: false
};
